export const LOT_TYPE = {
  NOT_SET: 0,
  WASHING: 1,
  CHARGING: 2,
  PARKING: 3,
  REFILLING: 4,
  DEBRIS_DUMP: 5,
} as const

/** UPPER_SNAKE_CASE (or API label) → readable text for UI. */
export function humanizeSnakeCaseLabel(value: string | number | null | undefined): string {
  if (value == null || value === '') {
    return '—'
  }
  const text = String(value).trim()
  if (!text || text === '—') {
    return '—'
  }
  if (!text.includes('_')) {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
  }
  return text
    .split('_')
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ')
}

export function isNotSetLabel(value: string | null | undefined): boolean {
  if (!value) {
    return true
  }
  return value.trim().toUpperCase().replace(/\s+/g, '_') === 'NOT_SET'
}

export const lotTypeMap: Record<number, string> = {
  [LOT_TYPE.NOT_SET]: 'Not set',
  [LOT_TYPE.WASHING]: 'Washing',
  [LOT_TYPE.CHARGING]: 'Charging',
  [LOT_TYPE.PARKING]: 'Parking',
  [LOT_TYPE.REFILLING]: 'Refill',
  [LOT_TYPE.DEBRIS_DUMP]: 'Debris dump',
}

export const statusTypeMap: Record<number, string> = {
  0: 'Not set',
  1: 'In progress',
  2: 'Succeeded',
  3: 'Safety fault',
  4: 'Canceled by robot',
  5: 'Command execution error',
}

export const occupiedStatusMap: Record<number, string> = {
  0: 'Undefined',
  1: 'Occupied',
  2: 'Released',
  3: 'Pending',
}

export const maintenanceStageMap: Record<number, string> = {
  0: 'Not set',
  1: 'Cancel',
  2: 'Prepare for docking',
  3: 'Finalize docking',
  4: 'Wash waste container',
  5: 'Fill water tank',
  6: 'Wash suction pipe',
  7: 'Start washing waste container top',
  8: 'Stop washing waste container top',
  9: 'Start washing cleaning equipment',
  10: 'Stop washing cleaning equipment',
  11: 'Start washing body left',
  12: 'Stop washing body left',
  13: 'Start washing body right',
  14: 'Stop washing body right',
  15: 'Prepare for undocking',
  16: 'Finalize undocking',
  17: 'Wash dirty water tank',
  18: 'Start charging',
  19: 'Stop charging',
  20: 'Dirty water drain',
}

export interface ILotEvent {
  id: number
  state_status: number
  error_code: number
  error_msg: string
  robot_sn: number | string
  timestamp: string
  lot_id: number
  type: number
}
